import React, { useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 10px;
  }
`;

const CustomPromptModal = ({
  show,
  onHide,
  customPrompt,
  setCustomPrompt,
  onSave,
  loading,
  section
}) => {
  const getSectionTitle = () => {
    switch (section) {
      case 'pricing':
        return 'Pricing';
      case 'window_cleaning':
        return 'Window Cleaning';
      case 'pressure_wash':
        return 'Pressure Washing';
      default:
        return 'Main Section';
    }
  };

  // Reset custom prompt when modal is closed
  useEffect(() => {
    if (!show) {
      setCustomPrompt('');
    }
  }, [show, setCustomPrompt]);

  return (
    <StyledModal
      show={show} onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Custom AI Prompt - {getSectionTitle()}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Edit your content</Form.Label>
            <Form.Control
              as="textarea"
              rows={10}
              value={customPrompt}
              onChange={(e) => setCustomPrompt(e.target.value)}
              placeholder="Enter your custom prompt for AI generation..."
              style={{ whiteSpace: 'pre-wrap' }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={onSave}
          disabled={!customPrompt.trim() || loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Generating...
            </>
          ) : (
            'Generate'
          )}
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
};

export default CustomPromptModal; 